

/**
 * @name AppointmentController
 * @description Controller called to displa and manage appointment details.
 * @param {Unknown} Association Service to get associations
 * @param {Unknown} ShopHours Service to get shop data
 * @param {Unknown} FormatShopHoursDescription Service to format the shop hours description
 * @param {Unknown} _ Lodash
 * @param {Unknown} $log Angular log service
 */
function ProfileController(
  Association,
  ShopHours,
  FormatShopHoursDescription,
  _,
  $log
) {
  let vm = this;
  $log.debug('Provider: ', vm.provider);

  // Determine the provider status. If the provider is undefined, we'll show
  // a 'Page not availabe' message. If the provider is a collector or artist,
  // we'll show a content not avaiable message. If it's a shop, we'll show the
  // shop profile
  if (_.isUndefined(vm.provider)) {
    vm.providerStatus = 'notFound';
  } else if (_.has(vm.provider, 'first_name') && vm.provider.artist) {
    vm.providerStatus = 'artist';
  } else if (_.has(vm.provider, 'first_name') && !vm.provider.artist) {
    vm.providerStatus = 'collector';
  } else if (_.has(vm.provider, 'name')) {
    // vm.providerStatus = 'shop'; <-- hidden for now
    // getShopArtists(vm.provider.id); <-- hidden for now
    // getShopHours(vm.provider.id); <-- hidden for now
    vm.providerStatus = 'notFound'; // Show not found for shop profiles till we
    // release this functionality
  }

  // /**
  //  * @name getShopArtists
  //  * @description Function to get shop artists from the associations api
  //  * @param {number} shopId The ID of the shop to filter by
  //  */
  // function getShopArtists(shopId) {
  //   Association.getShopAssociations(shopId)
  //   .then(function(associations) {
  //     vm.provider.artists = associations.artists;
  //   });
  // }

  // /**
  //  * @name getShopHours
  //  * @description Function to get shop hours
  //  * @param {number} shopId The ID of the shop to filter by
  //  */
  // function getShopHours(shopId) {
  //   ShopHours.get(shopId).then(function(hours) {
  //     vm.provider.hours = FormatShopHoursDescription.format(hours.current);
  //   });
  // }
}

angular
  .module('inkfinder')
  .controller('ProfileController', ProfileController);



// WEBPACK FOOTER //
// ./components/profile/profile.controller.js